export default __webpack_public_path__ + "static/media/axion-stats-dark.d139398f.png";